/*
 * @Author: huangtian1_v 1246562955@qq.com
 * @Date: 2025-04-05 18:15:58
 * @LastEditors: huangtian1_v 1246562955@qq.com
 * @LastEditTime: 2025-04-17 22:21:30
 * @FilePath: \yellowsky-blog\src\pages\Cp\Works\config.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const worksList = [
  {
    title: "迎客官网",
    desc: "服务于留学生的移动互联网服务！",
    img: require("@/assets/images/works/ykmobile.png"),
    url: "https://www.encmobile.com/",
  },
  {
    title: "CSDN博客笔记",
    desc: "一些工作中遇到的疑难杂症和解决方案",
    img: require("@/assets/images/works/csdn.png"),
    url: "https://blog.csdn.net/sky8880?spm=1019.2139.3001.5343",
  },
  {
    title: "视频智能分析",
    desc: "视频智能分析大屏",
    img: require("@/assets/images/works/视频智能分析.png"),
    url: "",
  },
  {
    title: "视频智能分析2",
    desc: "视频智能分析大屏2",
    img: require("@/assets/images/works/视频智能分析2.png"),
    url: "",
  },
  {
    title: "视频分析云数据",
    desc: "视频分析云数据大屏",
    img: require("@/assets/images/works/视频分析云数据.png"),
    url: "",
  },
  {
    title: "商机运营",
    desc: "商机运营大屏",
    img: require("@/assets/images/works/商机运营.png"),
    url: "",
  },
  {
    title: "河南商机大屏",
    desc: "河南商机大屏",
    img: require("@/assets/images/works/河南大屏.png"),
    url: "",
  },
];
